import { Footer } from "@components/site/Footer"
import { ScrollRestoration, useRoute } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("_app", (props) => {
  const route = useRoute()

  return (
    <>
      <ScrollRestoration />
      <div key={route.pathname} className="w-full">
        {props.children}
      </div>
      <Footer />

      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TVPKSMQD"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
    </>
  )
})
